<template>
  <v-simple-table class="px-5">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" translate>{{ $t(["Name"]) }}</th>
          <th class="text-left" translate>{{ $t(["Price"]) }}</th>
          <th class="text-left" translate>{{ $t(["Qty"]) }}</th>
          <th class="text-left" translate>{{ $t(["Total"]) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in orderCart" :key="item.name">
          <td v-html="$t([replaceHyphen(item.name)])" />
          <td v-html="$t('Currency', { amount: item.price.toFixed(2) })" />
          <td>{{ item.quantity }}</td>
          <td v-html="$t('Currency', { amount: item.total.toFixed(2) })" />
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "MerchandiseTable",
  props: {
    orderCart: undefined,
  },
  methods: {
    replaceHyphen(value) {
      return value.replace("-", "&#8209;");
    },
  },
};
</script>

<style lang="scss" scoped></style>
